import { render, staticRenderFns } from "./OwnerOtherDetails.vue?vue&type=template&id=941c2ebc"
import script from "./OwnerOtherDetails.vue?vue&type=script&lang=js"
export * from "./OwnerOtherDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports